<template>
  <a-drawer
    v-if="retreatmentVisible"
    title="患者复诊日程"
    placement="right"
    :visible="retreatmentVisible"
    :body-style="{ background: '#FFF', padding: 0 }"
    :headerStyle="{ background: '#FFF' }"
    @close="retreatmentVisible = false"
    width="400"
    :maskClosable="false"
  >
    <div class="content" :style="{ height: 'calc(100vh - 120px)' }">
      <a-spin :spinning="loading">
        <div v-if="!isSheet" class="orderDateTips" id="tips">
          需处理预约单：{{ orderPointToData.pointDate }} {{ orderPointToData.pointDateDetail }}
          <span v-if="orderPointToData.pointRevistType">｜</span>
          {{ orderPointToData.pointRevistType }}
        </div>
        <div class="calendarContainer">
          <a-calendar v-model:value="curDate" :fullscreen="false" @select="selectDateChange">
            <template #dateCellRender="{ current }">
              <!-- 这里的样式需要根据 appoint list 的内容确定 -->
              <template v-for="item in appointList" :key="item.reserveDate">
                <div
                  v-if="showDateTag(current, item)"
                  :class="[item.reserveTag === 2 && 'passed', item.reserveTag === 1 && 'events']"
                >
                  复
                </div>
              </template>
              <!-- <div
                v-if="appointList.includes(moment(current).format('YYYY-MM-DD'))"
                :class="[moment(current).isBefore(moment()) ? 'passed' : 'events']"
              >
                复
              </div> -->
            </template>
          </a-calendar>
        </div>
        <!-- 复诊预约单 -->
        <div
          v-for="(order, ordeDex) in curDayTreatedList"
          :key="ordeDex"
          :class="[
            'orderItem',
            selectPushDate.includes(order.id) ? 'orderItemActive' : 'orderItem'
          ]"
        >
          <div @click="selectTreated(order)">
            <div class="orderHead">
              <div class="orderId">
                复诊预约单
                <span v-if="floatBusinessId == order.id" style="color: #1890ff">
                  （ID:{{ order.id }}）
                </span>
              </div>
              <div v-if="order.patientProfileCommonVO?.patientProfileName" class="profileName">
                就诊人：{{ order.patientProfileCommonVO?.patientProfileName }}
              </div>
            </div>
            <div class="orderContent">
              <text>
                {{ order.reserveDateStr }}｜
                {{ ['线上问诊', '门诊就诊'][Number(order.revisitType) - 1] || '--' }}
              </text>
            </div>
          </div>
          <div class="orderAction">
            <span
              class="orderRelated"
              v-if="order.reserveSourceRelations.every(item => item.businessId)"
            >
              <a
                href="#"
                v-for="(relate, relateIndex) in order.reserveSourceRelations"
                :key="relateIndex"
                style="margin-right: 12px; font-size: 12px"
                @click="handleBussinessModal(relate)"
              >
                {{ `关联${relate.businessType === 1 ? '病历' : '处方'}${relateIndex + 1}` }}
              </a>
            </span>
            <span class="appointView">
              <a
                href="#"
                style="margin-right: 12px; font-size: 12px"
                @click="handleAppointView(order)"
              >
                查看预约单
              </a>
            </span>
          </div>
          <div
            :class="[
              'orderStatus',
              [0, 3, 4, 5, 6].includes(order.reserveState) ? 'warning' : '',
              [1].includes(order.reserveState) ? 'primary' : '',
              [2, 7].includes(order.reserveState) ? 'cancel' : ''
            ]"
          >
            {{ Config.RESERCE_STATE_MAP[order.reserveState] }}
          </div>
        </div>
        <div v-if="!isSheet && curDayTreatedList.length && customVisible">
          <div class="space"></div>
          <div class="helpHandle">
            <div class="tit">协助处理</div>
            <div class="action">
              <DoctorScheduleSheet />
              <ChatToRole receiver="patient" @ChatTo="retreatmentVisible = false" />
              <ChatToRole receiver="doctor" @ChatTo="retreatmentVisible = false" />
            </div>
          </div>
          <!-- 复诊跟踪工单 -->
          <RetreatTrackingOrder
            ref="orderRef"
            :workOrderGroupInfo="curWorkOrderInfo"
            @showSupplement="showSupplement"
            @confirmReserce="trckSelectRuleChange"
            v-if="[22].includes(workOrderType)"
          />
          <!-- 医生/患者不同意复诊日期 -->
          <NeedChangeRetreatOrder
            ref="orderRef"
            @showSupplement="showSupplement"
            :workOrderGroupInfo="curWorkOrderInfo"
            v-if="[24].includes(workOrderType)"
          />
          <!-- 医生/患者未确认复诊日期 -->
          <NotConfirmRetreatOrder
            ref="orderRef"
            :workOrderGroupInfo="curWorkOrderInfo"
            v-if="[25].includes(workOrderType)"
          />
          <!-- 有效扫码工单 -->
          <ScanEffectiveOrder
            ref="orderRef"
            :workOrderGroupInfo="curWorkOrderInfo"
            @showSupplement="showSupplement"
            v-if="[27].includes(workOrderType)"
          />
        </div>
        <!-- 直接修改预约单 不关联工单类型 -->
        <div v-if="isSheet && curDayTreatedList.length && selectPushDate?.length">
          <div class="space"></div>
          <div class="helpHandle">
            <div class="tit">协助处理</div>
            <div class="action">
              <DoctorScheduleSheet :bindUcDoctorId="`${ucDoctorId}`" />
              <ChatToRole receiver="patient" @ChatTo="retreatmentVisible = false" />
              <ChatToRole receiver="doctor" @ChatTo="retreatmentVisible = false" />
            </div>
          </div>
          <!-- 当前预约单selectPushMapList和selectPushDate只会有一个 一茜说-->
          <NormalChangeOrder
            ref="orderRef"
            :selectPushMap="selectPushMapList?.length > 0 ? selectPushMapList[0] : null"
            :ucPatientId="`${ucPatientId}`"
            :ucDoctorId="`${ucDoctorId}`"
          />
        </div>
      </a-spin>
      <div class="footer" v-if="curDayTreatedList.length && customVisible">
        <a-button @click="retreatmentVisible = false" :disabled="loading" class="cancle">
          取消
        </a-button>
        <a-button type="primary" @click="handleSubmitOrder" :disabled="loading" class="save">
          确定
        </a-button>
      </div>
    </div>
    <RecordDetail v-model:visible="recordVisible" recordType="offLineRecord" :id="recordId" />
    <the-detail
      v-model:visible="presVisible"
      :serialNumber="serialNumber"
      recordType="prescriptionOnline"
    />
    <ADetail ref="aDetail" :recordId="appointId" />
  </a-drawer>
</template>
<script setup>
// import { saveOfflineCase } from '@/api/HealthRecord/index.js'
import {
  ref,
  defineExpose,
  defineProps,
  computed,
  defineEmits,
  createVNode,
  reactive,
  nextTick
} from 'vue'
import moment from 'moment'
import {
  // apiReverseDateList,
  apiDayReverseInfo,
  apiConfirmReversed,
  apiEffectiveScanAudit,
  apiOrderOperateHistory,
  queryCureReserveTag
} from '@/api/workPlace/retreatment.js'
import { appointRecordIdApi } from '@/api/workPlace/appoint'
import DoctorScheduleSheet from '@/components/Retreatment/doctorScheduleSheet.vue'
import ChatToRole from '@/components/Retreatment/chatToRole.vue'
import NeedChangeRetreatOrder from './components/needChangeRetreatOrder'
import NotConfirmRetreatOrder from './components/notConfirmRetreatOrder.vue'
import RetreatTrackingOrder from './components/retreatTrackingOrder.vue'
import ScanEffectiveOrder from './components/scanEffectiveOrder.vue'
import NormalChangeOrder from './components/normalChangeOrder.vue'
import { useStore } from 'vuex'
import Config from '@/config/index'
import { message, Modal } from 'ant-design-vue'
import RecordDetail from '@/components/TheDetail'
import TheDetail from '@/components/TheDetail/index.vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { debounce } from 'lodash-es'
import { REFRESH_MAIN } from '@/views/WorkPlace/handleEventBuss'
import { handleTimeShowWeek } from '@/utils'
import ADetail from '@/views/WorkPlace/components/Appoint/index.vue'
const store = useStore()
const retreatmentVisible = ref(false)
const curWorkOrderInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
const curBussinessType = computed(() => curWorkOrderInfo.value.targetWorkOrder.businessType)
const ucPatientId = computed(
  () => propsUser.value?.ucPatientId || curWorkOrderInfo.value?.patientInfo?.ucUserId
)
const ucDoctorId = computed(
  () => propsUser.value?.ucDoctorId || curWorkOrderInfo.value?.doctorInfo?.ucUserId
)
const patientId = computed(
  () => propsUser.value?.patientId || curWorkOrderInfo.value?.patientInfo?.businessId
)
const doctorId = computed(
  () => propsUser.value?.doctorId || curWorkOrderInfo.value?.doctorInfo?.businessId
)
const props = defineProps({
  isSheet: {
    type: Boolean,
    default: false
  },
  // 定位日期
  targetDate: {
    type: String,
    default: ''
  }
})

const workOrderType = ref()
const floatBusinessId = ref()
const orderPointToData = reactive({
  pointDate: null,
  pointDateDetail: null,
  pointRevistType: null
})
// 穿进来的患者信息
const propsUser = ref(null)
const treatmentInit = async (bussinessOrderType, args = null, UserInfo = null) => {
  workOrderType.value = bussinessOrderType
  retreatmentVisible.value = true
  // NOTE: 如果外部穿传递参数那么就用参数的用户信息
  propsUser.value = UserInfo
  //获取预约单详情
  if (args) {
    floatBusinessId.value = args
    const result = await appointRecordIdApi({ reserveId: args })
    curDate.value = moment(result.reserveDate).format('YYYY-MM-DD')
    orderPointToData.pointDate = handleTimeShowWeek(result.reserveDate, 'YYYY-MM-DD')
    orderPointToData.pointDateDetail = result.reserveDateDetail
      ? ['上午', '下午'][result.reserveDateDetail - 1]
      : ''
    orderPointToData.pointRevistType = result.revisitType
      ? ['线上问诊', '门诊就诊'][result.revisitType - 1]
      : ''
    fetchReverseList()
  } else if (props.targetDate) {
    // 使用传入的 targetDate
    curDate.value = moment(props.targetDate).format('YYYY-MM-DD')
    fetchReverseList()
  } else {
    curDate.value = moment().format('YYYY-MM-DD')
    fetchReverseList()
  }
}

const curDate = ref(null)
const appointList = ref([])
// 是否显示tag复字
const showDateTag = computed(() => {
  return function (current, item) {
    const cDate = moment(current).format('YYYY-MM-DD')
    // 日期相同并且有标签提示 （reserveTag）
    const show = cDate === item.reserveDate && item.reserveTag
    return show
  }
})
const fetchReverseList = () => {
  appointList.value = []
  // 废弃
  // apiReverseDateList({
  //   ucDoctorId: curWorkOrderInfo.value.doctorInfo.ucUserId,
  //   ucPatientId: curWorkOrderInfo.value.patientInfo.ucUserId
  // }).then(res => {
  //   appointList.value = res
  //   selectDateChange(curDate.value, floatBusinessId.value)
  // })
  const params = {
    ucPatientId: ucPatientId.value,
    reserveDateMin: null,
    reserveDateMax: null,
    ucDoctorId: ucDoctorId.value,
    prescribe: false
  }
  queryCureReserveTag(params).then(result => {
    // reserveTag 复诊标签：1-高亮 2-置灰， reserveDate
    appointList.value = result
    selectDateChange(curDate.value, floatBusinessId.value)
  })
}

const customVisible = computed(() => {
  return [22, 27].includes(workOrderType.value) ? true : selectPushDate.value.length
})

const trackIsLevel2 = ref(false)
const trckSelectRuleChange = ctxSign => {
  trackIsLevel2.value = ctxSign === 1 ? false : true
  if (ctxSign === 1) {
    selectPushDate.value = []
    selectPushMapList.value = []
  } else {
    const A = curDayTreatedList.value.find(item => {
      return [0, 3, 5, 6].includes(item.reserveState)
    })
    if (A) {
      const target = document.getElementById('tips')
      target.scrollIntoView({ block: 'start', behavior: 'smooth' })
      selectTreated(A)
    } else {
      ctxSign === 2 && message.warning('当前无可修改的预约单！')
    }
  }
}

const selectPushDate = ref([])
const selectPushMapList = ref([])
const selectTreated = async ctx => {
  if (!ctx) return
  if ([27].includes(workOrderType.value)) return
  if (workOrderType.value === 22 && !trackIsLevel2.value) return
  if (selectPushDate.value.includes(ctx.id)) {
    const index = selectPushDate.value.findIndex(item => item === ctx.id)
    if (selectPushDate.value.length !== 1) {
      selectPushDate.value.splice(index, 1)
      selectPushMapList.value.splice(index, 1)
    } else {
      message.warning('至少选择一条要处理的预约单！')
    }
  } else {
    if ([0, 3, 5, 6].includes(ctx.reserveState)) {
      selectPushDate.value.push(ctx.id)
      selectPushMapList.value.push(ctx)
    }
  }
}

const loading = ref(false)
const curDayTreatedList = ref([])
const selectDateChange = (ctx, defaultReserveId) => {
  trackIsLevel2.value = false
  curDayTreatedList.value = []
  selectPushDate.value = []
  selectPushMapList.value = []
  const dataFormat = moment(ctx).format('YYYY-MM-DD')
  const reserveDates = appointList.value.filter(f => !!f.reserveTag).map(m => m.reserveDate)
  if (reserveDates.includes(dataFormat)) {
    loading.value = true
    apiDayReverseInfo({
      ucDoctorId: ucDoctorId.value,
      ucPatientId: ucPatientId.value,
      reserveDate: dataFormat,
      relationDetail: true
    }).then(res => {
      curDayTreatedList.value = res.list
      if (![22, 27].includes(workOrderType.value)) {
        const A = res.list.find(item => {
          return defaultReserveId
            ? item.id === Number(defaultReserveId)
            : [0, 3, 5, 6].includes(item.reserveState)
        })
        selectTreated(A)
      }
      loading.value = false
    })
  }
}

const orderRef = ref()
const emits = defineEmits(['showSupplement', 'changeReverseDate'])
const handleSubmitOrder = debounce(async () => {
  try {
    const orderParams = await orderRef.value.mainformValid()
    const formParams = await orderRef.value.submitForm()
    const submitParams = { ...formParams, ...orderParams }
    // const reserveId = curWorkOrderInfo.value.targetWorkOrder.quickDealNavigationBusinessId
    const reserveIdList = selectPushDate.value
    const workOrderId = curWorkOrderInfo.value?.targetWorkOrder?.workOrderId
    const completeCureReserveDate = moment(curDate.value).format('YYYY-MM-DD')
    const relationIds = {
      doctorId: doctorId.value,
      ucDoctorId: ucDoctorId.value,
      patientId: patientId.value,
      ucPatientId: ucPatientId.value
    }

    // 直接修改复诊信息
    if (props.isSheet) {
      if (!reserveIdList.length) {
        return message.warning('当前无可修改的预约单！')
      }
      const { isCancel, reserveDate, reserveDateDetail, revisitType, confirmed } = submitParams
      apiConfirmReversed({
        reserveIdList,
        confirmed: confirmed || false,
        isCancel,
        reserveDate,
        reserveDateDetail,
        revisitType,
        source: 1,
        reserveEntry: 16,
        modifyReserveDateFlag: 1 //新增埋点 暂时写死1
      }).then(() => {
        emits('changeReverseDate')
        retreatmentVisible.value = false
        REFRESH_MAIN?.emit()
      })
      return
    }

    switch (curBussinessType.value) {
      case 22:
        if (submitParams.confirmed === null) {
          return message.warning('请选择协助处理结果！')
        }
        if (submitParams.confirmed === 1) {
          apiEffectiveScanAudit({
            ...relationIds,
            ...orderParams,
            completeCureReserveDate,
            workOrderId,
            notNeedReserve: submitParams.isCancel
          }).then(() => {
            dueCallBack()
          })
        } else if (submitParams.confirmed === 2) {
          // 修改复诊信息
          if (!reserveIdList.length) {
            return message.warning('当前无可修改的预约单！')
          }
          const { isCancel, reserveDate, reserveDateDetail, revisitType } = submitParams
          apiConfirmReversed({
            reserveIdList,
            confirmed: false,
            isCancel,
            reserveDate,
            reserveDateDetail,
            revisitType,
            reserveEntry: 14,
            modifyReserveDateFlag: 1
          }).then(res => {
            dueCallBack(res)
          })
        }
        break
      // 直接修改复诊信息
      case 24:
        if (!reserveIdList.length) {
          return message.warning('当前无可修改的预约单！')
        }
        if (submitParams.confirmed === null) {
          return message.warning('请选择协助处理结果！')
        }
        // if (true) {
        //   saveOfflineCase(SParams.value).then(res => {
        //     dueCallBack(res)
        //   })
        // } else {
        apiConfirmReversed({
          confirmed: submitParams.confirmed,
          reserveIdList,
          reserveEntry: 17,
          modifyReserveDateFlag: 1,
          ...submitParams
        }).then(res => {
          dueCallBack(res)
        })
        // }
        break
      case 25:
        Modal.confirm({
          centered: true,
          title: '提示',
          icon: createVNode(ExclamationCircleOutlined),
          content:
            '确定修改复诊日期/方式？提交后系统推送医生和患者复诊日期/方式结果，不再进行确认。',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            if (!reserveIdList.length) {
              return message.warning('当前无可修改的预约单！')
            }
            apiConfirmReversed({
              reserveIdList,
              reserveEntry: 15,
              modifyReserveDateFlag: 1,
              ...submitParams
            }).then(res => {
              dueCallBack(res)
            })
          }
        })
        break
      case 27:
        if (submitParams.confirmed) {
          // const { reserveDate, reserveDateDetail, revisitType, isCancel } = submitParams
          apiEffectiveScanAudit({
            ...relationIds,
            ...orderParams,
            completeCureReserveDate,
            workOrderId
          }).then(() => {
            dueCallBack()
          })
        } else {
          dueCallBack()
        }
        break
    }
  } catch (error) {
    message.warning('请选择必填项！')
    console.log('error', error)
  }
}, 400)

// 关联病历
const recordId = ref('')
const recordVisible = ref(false)
// 关联处方
const serialNumber = ref('')
const presVisible = ref(false)
const handleBussinessModal = ctx => {
  if (ctx.businessType === 1) {
    recordVisible.value = true
    recordId.value = ctx.businessId
  }
  if (ctx.businessType === 2) {
    presVisible.value = true
    serialNumber.value = ctx.serialNumber
  }
}
const aDetail = ref(null)
const appointId = ref('')
// 查看预约单
const handleAppointView = ctx => {
  appointId.value = ctx.id.toString()
  nextTick(() => {
    aDetail.value.mVisible = true
    aDetail.value.initDetail()
  })
}
const showSupplement = e => {
  emits('showSupplement', e)
}
// 外部传来的参数（任意数据）
const SParams = ref({})
const receiveSupplementParams = args => {
  orderRef.value?.passSupplementParams(args)
  SParams.value = args
}

const dueCallBack = async (res = true) => {
  message.success('提交成功！')
  res &&
    (await apiOrderOperateHistory({
      operationBusinessId: curWorkOrderInfo.value.targetWorkOrder.workOrderId,
      operationName: curWorkOrderInfo.value?.curDocAss.username,
      operationDesc: ''
    }))
  retreatmentVisible.value = false
  REFRESH_MAIN?.emit()
}

defineExpose({
  receiveSupplementParams,
  retreatmentVisible,
  treatmentInit
})
</script>

<style scoped lang="scss">
@import './calendarReset.scss';

.content {
  overflow: scroll;
  padding-bottom: 40px;
}

.orderDateTips {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  background-color: #fff5ea;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  padding: 0 16px;
}

.orderItem {
  background: #f5f5f7;
  border-radius: 8px;
  margin-bottom: 12px;
  position: relative;
  margin: 12px 18px 20px;
  border: 1px solid transparent;

  .orderHead {
    font-size: 13px;
    color: #999999;
    border-bottom: 1px solid #e3e3e3;
    padding: 8px 16px;
    padding-right: 50px;
    display: flex;
    flex-direction: row;
    .orderId {
      flex-shrink: 0;
    }
    .profileName {
      padding-left: 12px;
    }
  }
  .orderContent {
    padding: 12px 16px;
    color: #1b1b1b;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .orderAction {
    padding: 0px 16px 12px;
  }
  .orderStatus {
    position: absolute;
    top: 0;
    right: 0;
    background: #2ed1b5;
    border-radius: 0 8px 0 8px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    padding: 3px 5px;
    &.primary {
      background: #4c6ee0;
    }
    &.cancel {
      background: #9e9e9e;
    }
    &.warning {
      background: #f4ae54;
    }
  }
}

.orderItemActive {
  border: 1px solid #1e7bff;
  border-radius: 8px;
  background-color: rgba(152, 215, 255, 0.15);
}

.helpHandle {
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid #f0f0f0;
  border-top: 10px solid #f5f5f5;
  .tit {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-right: 40px;
  }
  .action {
    font-size: 14px;
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
}

.footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 15px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;

  .cancle {
    width: 112px;
    margin-right: 12px;
    height: 36px;
    font-size: 16px;
  }
  .save {
    width: 112px;
    height: 36px;
    font-size: 16px;
  }
}
</style>
